// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'
const serveName = process.env.VUE_APP_SERVENAME

// 查询产品信息
export const queryGoodsOption = (data?: any) => request(`/${serveName}/app/dimension`, null, 'POST_JSON', data)

// 根据产品ID获取其渠道信息
export const queryChnlOption = (data: { dbtId: string }) =>
  request(`/${serveName}/product/getProdTypeByDbtId`, null, 'POST_JSON', data)

// 获取本地语言下拉框数据
export const queryLangOption = (data: { prodChnl: string }) =>
  request(`/${serveName}/product/getNativeInfoList`, null, 'POST_JSON', data)

// 获取国家货币关系信息
export const queryCountryCoinOptions = (data: { prodChnl: string }) =>
  request(`/${serveName}/product/getAccountCountry2Currency`, null, 'POST_JSON', data)

// 获取包名默认价格国家信息
export const queryPkgInfo = (data: { dbtId: string; prodChnl: string }) =>
  request(`/${serveName}/product/getAppInfoByDbtIdAndProdChnl`, null, 'POST_JSON', data)

// 根据产品ID和渠道获取商品列表信息
export const queryGoodsList = (data: goodsSetting.queryGoodsListParams) =>
  request(`/${serveName}/product/getProductList`, null, 'POST_JSON', data)

// 查询商品
export const queryGoods = (data: goodsSetting.queryGoodsParams) =>
  request(`/${serveName}/product/getProduct`, null, 'POST_JSON', data)

// 价格信息查询
export const queryPriceList = (data: goodsSetting.queryPriceParams) =>
  request(`/${serveName}/product/price/getDefaultNativePrices`, null, 'POST_JSON', data)

// 新增商品
export const addGoods = (data: goodsSetting.tableDataItem) =>
  request(`/${serveName}/product/addProduct`, null, 'POST_JSON', data)

// 编辑商品
export const updGoods = (data: goodsSetting.tableDataItem) =>
  request(`/${serveName}/product/modProduct`, null, 'POST_JSON', data)

// 提交商品
export const submitGoods = (data: { productList: { id: number }[] }) =>
  request(`/${serveName}/product/submitProduct`, null, 'POST_JSON', data)

// 删除商品
export const delGoods = (data: { id: number; prodChnl: any }) =>
  request(`/${serveName}/product/delProduct`, null, 'POST_JSON', data)

// 上线商品
export const onlineGoods = (data: { productList: { id: number }[]; prodChnl: string }) =>
  request(`/${serveName}/product/onlineProduct`, null, 'POST_JSON', data)

// 下线商品
export const offlineGoods = (data: { productList: { id: number }[]; prodChnl: string }) =>
  request(`/${serveName}/product/offlineProduct`, null, 'POST_JSON', data)

// 校验商品
export const verifyGoodsPrice = (data: goodsSetting.verifyGoodsPriceParams) =>
  request(`/${serveName}/product/checkNativePriceRange`, null, 'POST_JSON', data)

// 获取详情基础方案模块下拉框数据
export const queryBasicPlanSelections = (data: { prodChnl: string }) =>
  request(`/${serveName}/product/getMetadata`, null, 'POST_JSON', data)

// 导入商品
export const importGoods = (data: any) =>
  request(`/${serveName}/product/importProduct`, null, 'POST_FILE', data, 600000)

// 导出商品
export const exportGoods = (data: any) => request(`/${serveName}/product/exportProduct`, null, 'POST_DOWNLOAD', data)

// 导出csv
export const exportGoodsCsv = (data: any) =>
  request(`/${serveName}/product/exportProductByChannel`, null, 'POST_DOWNLOAD', data)

// 获取产品渠道
export const getProdChannelCodeList = (data: any) =>
  request(`/${serveName}/project/product/getProdChannelCodeList`, null, 'POST_JSON', data)

// 批量修改价格
export const batchChangePrice = (data: { changePriceType: number; productList: { id: number }[] }) =>
  request(`/${serveName}/product/product/batchChangePrice`, null, 'POST_JSON', data)

// 翻译
export const translator = (data: any) => request(`/${serveName}/product/translator`, null, 'POST_JSON', data)

// 获取历史价格接口
export const getLastLangInfo = (data: any) => request(`/${serveName}/product/lastLangInfo`, null, 'POST_JSON', data)

// 调整商品价格
export const changeGoodsPrice = (data: any) => request(`/${serveName}/product/modProduct`, null, 'POST_JSON', data)

// 批量删除
export const batchDelete = (data: any) => request(`/${serveName}/product/batchDelProduct`, null, 'POST_JSON', data)
